import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import OphaalForm from './pages/OphaalForm';
import AfleverForm from './pages/AfleverForm';
import OmruilForm from './pages/OmruilForm';
import InnameForm from './pages/InnameForm';
import ConfirmationPage from './pages/ConfirmationPage';
import { FormChangeProvider } from './contexts/FormChangeContext';

function App() {
  return (
    <FormChangeProvider>
      <div className="min-h-screen bg-neutral-50">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ophaal" element={<OphaalForm />} />
          <Route path="/aflever" element={<AfleverForm />} />
          <Route path="/omruil" element={<OmruilForm />} />
          <Route path="/inname" element={<InnameForm />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
        </Routes>
      </div>
    </FormChangeProvider>
  );
}

export default App;